<template>
  <nx-scrollytelling-field
    v-validate="validation"
    :disabled="disabled"
    :data-vv-name="name"
    :data-vv-scope="scope"
    :data-vv-as="label"
    data-vv-value-path="value"
    :name="name"
    :value="value"
    :preview-url="getPreviewUrl()"
    :loading="loading"
    @input="handleInput"
    @move="handleMove"
    v-bind="$attrs"/>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';
import NxScrollytellingField from '@/modules/scrollytelling/ScrollytellingField';
import { mapGetters } from 'vuex';

export default {
  name: 'nx-form-scrollytelling-field',
  inject: {
    $getParentEditor: {
      default: () => ({}),
    },
  },
  components: { NxScrollytellingField },
  mixins: [FormElement],
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    collectionId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async handleInput(value) {
      try {
        this.loading = true;
        await this.$parentForm.updateField(this.name, value);
        await this.$getParentEditor().save();
        await this.$store.dispatch('scrollytelling/INCREMENT_PREVIEW_KEY');
      } finally {
        this.loading = false;
      }
    },
    handleMove(value) {
      this.$parentForm.updateField(this.name, value);
    },
    getPreviewUrl() {
      return `${this.$getParentEditor().getters.previewUrl}${this.slideIdBeingEdited ? `#${this.slideIdBeingEdited}` : ''}`;
    },
  },
  computed: {
    ...mapGetters('scrollytelling', [
      'slideIdBeingEdited',
    ]),
  },
  async mounted() {
    await this.$store.dispatch('scrollytelling/SET_COLLECTION_ID', this.collectionId);
  },
};
</script>
